import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const WizardSteps = props => {
  const underline = <div className="active-underline complete" />
  return (
    <div className="step_header_container">
      <div id="page-heading">
        <h2 className="text-center page-header">
          {props.edit ? 'Edit' : 'New'} {props.heading}
        </h2>
      </div>
      <div className="step-container">
        <div className="number-container">
          <Link to={props.linkPaths.design}>
            <p
              className={`number ${props.step === 1 ? 'active' : 'inactive'} ${
                props.step >= 1 ? 'complete' : ''
              }`}
            >
              1
            </p>
            {props.step === 1 ? underline : ''}
          </Link>
        </div>
        <div
          className={`icon icon_arrow_right4 ${
            props.step > 1 ? 'complete' : ''
          }`}
        />
        <div className="number-container">
          <Link to={props.linkPaths.requirements}>
            <p
              className={`number ${props.step === 2 ? 'active' : 'inactive'} ${
                props.step >= 2 ? 'complete' : ''
              }`}
            >
              2
            </p>
            {props.step === 2 ? underline : ''}
          </Link>
        </div>
        <div
          className={`icon icon_arrow_right4 ${
            props.step > 2 ? 'complete' : ''
          }`}
        />
        <div className="number-container">
          <Link to={props.linkPaths.review}>
            <p
              className={`number ${props.step === 3 ? 'active' : 'inactive'} ${
                props.step >= 3 ? 'complete' : ''
              }`}
            >
              3
            </p>
            {props.step === 3 ? underline : ''}
          </Link>
        </div>
      </div>
      <div className="sub-heading">
        <p className="sub-header">{props.subHeading}</p>
        <p className="sub-heading-annotation">{props.annotation}</p>
      </div>
    </div>
  )
}

WizardSteps.propTypes = {
  step: PropTypes.number.isRequired,
  heading: PropTypes.string.isRequired,
  linkPaths: PropTypes.object.isRequired,
  subHeading: PropTypes.string,
  annotation: PropTypes.string,
  edit: PropTypes.bool,
}

export default WizardSteps
